export default function accordion() {
  document.addEventListener("DOMContentLoaded", function () {
    $(function () {
      $('.m3pcom-help-list--inner').css("display", "none");
      $('.m3pcom-js-help-btn').on('click', function () {
        $(this).next().slideToggle(300);
      })
    });

    function initAccordion() {
      document.querySelectorAll('[data-accordion-toggle-btn]').forEach((accordionBtn) => {
        const accordionName = accordionBtn.dataset.accordionToggleBtn;
        if(!accordionName) { return }

        const targetArea = document.querySelector(`[data-accordion-area="${accordionName}"]`)
        if(!targetArea) { return }

        if(accordionBtn.dataset.isNeedAccordion === 'false'){
          const targetInner = document.querySelector(`[data-accordion-inner="${accordionName}"]`)
          if(!targetInner) { return }
          const threshold = targetInner.dataset.accordionThreshold
          if (targetInner.scrollHeight > threshold) {
            accordionBtn.dataset.isNeedAccordion = 'true'
          }
        };

        accordionBtn.addEventListener('click', () => {
          targetArea.dataset.accordionStatus = 'show';
          accordionBtn.remove()
        });
      });
    }
    window.initAccordion= initAccordion;
    initAccordion();
  });
}
